/*
 Created by qing on 2022/4/6 下午6:15
 Des: 关联飞书审批
 */

import BaseItem from "../BaseItem"
import {
  DATA_TYPE__ARRAY,
  FORM_ITEM__LARK_APPROVAL, FORM_ITEM__TABLE
} from "../types"

class LarkApproval extends BaseItem {

  constructor() {
    super()

    this.value = []

    this.relateApproval = "ALL" //ALL 全部 CHOOSE 指定
    this.approvalList = [
      // {
      //   "approvalCode":"", //关联审批Id
      //   "approvalName":""  //关联的名称
      // }
    ]
    this.showAgreeOnly = "YES" //仅仅显示审批通过的应用
    this.relateInstanceType = "ONE" //ONE 单个 MORE 多个

    this.defaultValue = {}
  }

  get title() {
    return this.fieldTitle || LarkApproval._title
  }

  set title(val) {
    this.fieldTitle = val
    this.temTitle = val
  }
}

LarkApproval._title = '关联飞书审批'
LarkApproval.type = FORM_ITEM__LARK_APPROVAL
LarkApproval.use = true
LarkApproval.prototype.icon = 'el-icon-video-play'

LarkApproval.prototype.type = LarkApproval.type
LarkApproval.prototype.dataType = DATA_TYPE__ARRAY
LarkApproval.prototype.defaultValueList = []

LarkApproval.prototype.filterOpts = [
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
LarkApproval.prototype.getValue = function () {
  return this.value
}
LarkApproval.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || []
}
LarkApproval.prototype.setConf = function (opts) {
  this.setBase(opts)
  this.relateApproval = opts.relateApproval
  this.approvalList = opts.approvalList
  this.showAgreeOnly = opts.showAgreeOnly
  this.relateInstanceType = opts.relateInstanceType
}
LarkApproval.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    relateApproval: this.relateApproval,
    approvalList: this.approvalList,
    showAgreeOnly: this.showAgreeOnly,
    relateInstanceType: this.relateInstanceType
  }
}
LarkApproval.prototype.valueToString = function (value) {
  value = value || this.value
  return value
}
export default LarkApproval
